if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (
					document.querySelector("cart-drawer") &&
					document.getElementById("cart-icon-bubble")?.classList.contains("cart-flyout-active")
				)
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				/* Gravur: Leer/Leerzeichen blocken (nvvalidate auf dem Produktformular schaltet natives required aus) */
				for (const el of this.form.elements) {
					if (el.nodeName !== "TEXTAREA" || !el.classList?.contains("product-gravur__input"))
						continue;
					if (!el.hasAttribute("data-gravur-trim-required")) continue;
					if (el.value.trim()) continue;
					el.setCustomValidity(el.dataset.gravurTrimMessage || " ");
					el.reportValidity();
					el.setCustomValidity("");
					return;
				}

				if (!this.form.checkValidity()) {
					this.form.reportValidity();
					return;
				}

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");

				const buildFormData = () => {
					const formData = new FormData(this.form);
					if (this.dataset.marketingProduct === "true") {
						formData.set("quantity", "1");
					}
					if (this.cart) {
						formData.append(
							"sections",
							this.cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					}
					return formData;
				};

				const submitAddToCart = () => {
					const config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];
					config.body = buildFormData();

					return fetch(`${routes.cart_add_url}`, config);
				};

				const marketingCheck =
					this.dataset.marketingProduct === "true"
						? fetch(`${routes.cart_url}.js`)
								.then((response) => response.json())
								.then((cart) => {
									const productId = Number(this.dataset.productId);
									const alreadyInCart = cart.items.some(
										(item) => item.product_id === productId
									);
									if (!alreadyInCart) return submitAddToCart();

									const errorMessage =
										this.dataset.marketingError ||
										"This product can only be added to the cart once.";
									this.handleErrorMessage(errorMessage);
									document.dispatchEvent(
										new CustomEvent("cart:error", {
											detail: {
												sectionId: this.dataset.source,
												productVariantId: this.form.querySelector("[name=id]")?.value,
												errors: errorMessage,
												message: errorMessage,
											},
										})
									);
									publish(PUB_SUB_EVENTS.cartError, {
										source: "product-form",
										productVariantId: this.form.querySelector("[name=id]")?.value,
										errors: errorMessage,
										message: errorMessage,
									});
									return null;
								})
								.catch((e) => {
									console.error(e);
									return submitAddToCart();
								})
						: submitAddToCart();

				marketingCheck
					.then((response) => {
						if (!response) return null;
						return response.json();
					})
					.then(async (response) => {
						if (!response) return;
						const variantId = this.form.querySelector("[name=id]")?.value;
						const quantity = this.dataset.marketingProduct === "true"
							? 1
							: Number(this.form.querySelector("[name=quantity]")?.value || 1);

						if (response.status) {
							// CART ERROR EVENT
							document.dispatchEvent(
								new CustomEvent('cart:error', {
									detail: {
										sectionId: this.dataset.source,
										productVariantId: variantId,
										errors: response.description,
										message: response.message,
									},
								})
							)
							// -------------------------------------------

							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: variantId,
								errors: response.description,
								message: response.message,
							})
							this.handleErrorMessage(response.description)

							const soldOutMessage =
								this.submitButton.querySelector('.sold-out-message')
							if (!soldOutMessage) return
							this.submitButton.setAttribute('aria-disabled', true)
							this.submitButton.querySelector('span').classList.add('hidden')
							soldOutMessage.classList.remove('hidden')
							this.error = true
							return
						}

						if (this.dataset.cartAttributeKey) {
							await fetch(`${routes.cart_update_url}`, {
								...fetchConfig(),
								body: JSON.stringify({
									attributes: {
										[this.dataset.cartAttributeKey]:
											this.dataset.cartAttributeValue || "true",
									},
								}),
							});
						}

						if (!this.cart) {
							window.location = window.routes.cart_url
							return
						}

						const lines = response.items || [];
						const lineMatch = lines.find(
							(it) => String(it.variant_id) === String(variantId)
						);
						const productIdFromAdd =
							(lineMatch && lineMatch.product_id) ||
							(lines.length && lines[lines.length - 1].product_id) ||
							null;

						// VARIANT ADDED EVENT
						document.dispatchEvent(
							new CustomEvent('variant:add', {
								detail: {
									variant: {
										id: variantId,
									},
									productId: productIdFromAdd,
									quantity: quantity,
									formElement: this.form,
									sectionId: this.dataset.source,
								},
							})
						)
						// -------------------------------------------

						fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

						if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: variantId,
							})
						}
						this.error = false
						const quickAddModal = this.closest('quick-add-modal')
						if (quickAddModal) {
							document.body.addEventListener(
								'modalClosed',
								() => {
									setTimeout(() => {
										this.cart.renderContents(response)
									})
								},
								{once: true}
							)
							quickAddModal.hide(true)
						} else {
							this.cart.renderContents(response)
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
